"use client";
import React, { useState } from "react";
import Button from "../../../ui/Button";
import { HomeOneIcon, HomeThreeIcon, HomeTwoIcon } from "../DesignOneIcons";
const data = [
  {
    icon: <HomeOneIcon />,
    title: "Buy Property",
    text: "Looking to buy property? Whether residential, commercial, or investment opportunities, we’ve got you covered. Explore properties tailored to your needs and budget. Start your search today!",
    buttonText: "Explore Property",
    buttonUrl: "/properties/sale",
  },
  {
    icon: <HomeTwoIcon />,
    title: "Rent Property",
    text: "Looking to rent a property? We offer a variety of options to meet your needs. Explore properties in your preferred location, compare choices, and find the perfect deal that suits your interests.",
    buttonText: "Find Property",
    buttonUrl: "/properties/rent",
  },
  {
    icon: <HomeThreeIcon />,
    title: "Sell Property ",
    text: "Looking to sell your property quickly or in need of efficient rental property management? Our company offers a seamless solution for property owners to showcase their assets to potential clients.",
    buttonText: "Contact Us",
    buttonUrl: "/contact",
  },
];

export const SecondSectionCards = () => {
  return (
    <div
      className="grid mt-8 sm:!grid-cols-1 carding 
     max-w-[1200px] mx-auto  grid-cols-3 gap-8"
    >
      {data.map((data, index) => {
        return <Card key={index} {...data} />;
      })}
    </div>
  );
};

export const Card: React.FC<{
  icon: React.JSX.Element;
  title: string;
  text: string;
  buttonText: string;
  buttonUrl: string;
}> = ({ icon, title, text, buttonText, buttonUrl }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <article
      onMouseEnter={() => {
        setHovered(true);
      }}
      onMouseLeave={() => {
        setHovered(false);
      }}
      style={{
        boxShadow: `${hovered ? "4px 4px 50px 0px #2121211A" : ""}`,
      }}
      className={`flex transition xs:!max-w-[350px] xlg:max-w-[400px] mx-auto text-secondary-main p-6 duration-700 flex-col items-center ${
        hovered && "scale-[1.1] bg-white"
      } rounded-md gap-6`}
    >
      <span className="size-[7.5rem]">{icon}</span>
      <h3 className="text-secondary-main h5 font-medium">{title}</h3>
      <p className="text-center">{text}</p>
      <Button className="w-max primary-btn !px-8 !py-3" href={buttonUrl}>
        {buttonText}
      </Button>
    </article>
  );
};
